import { useParams } from "react-router-dom";
import React, { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Editsonsectionname = () =>{
    const [photo, setPhoto] = useState('');
    const [name, setName] = useState('');
    let navigt = useNavigate();
    let { id } = useParams();
    const handleImage =(e)=>{
        setName(e.target.files[0]) 
    }
    const  formSubmit = (e)=>{
        e.preventDefault()
        const formData = new FormData()
      //  formData.append('photo', photo)
        formData.append('name', name)
 
        axios.post(`https://backend.dasta.net/api/auth/updateworksectionsonControllerphoto/${id}`,formData ).then((res)=>{
            console.log(res)
        }).then((data)=>{
            navigt(-1);
        })
    }  

    return(
        <>
        <form onSubmit={formSubmit}>
            {/* <input type="file" name="file" onChange={(e)=>setPhoto(e.target.files[0])}/>    */}
                <label>Please Enter descrption::</label>
                <input type="text" id="fname" name="fname" onChange={(e)=>setName(e.target.value)}/>
            <button type='submit' >submit</button>
        </form>
        </>
    )

}
export default Editsonsectionname;